import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";

function Settings() {
    const { t } = useTranslation();

    document.title = `Yoda - ${t('app.settings')}`;

    return (
        <div className="Setting">
            <Outlet />
        </div>
    );
}

export default Settings;
